import React, { useState, useEffect } from "react";
import styles from "./Css/OverlayHome.module.css";
import { Play,  Info, BookOpen } from "lucide-react";
import Loading from "../../common/HousGlass Loader/Loading";
import { useHeroSectionsByTypePublic } from "../../hooks/herosection/useHeroSectionPublicHooks";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade, Pagination } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';

const OverlayHome = ({type, category}) => {
  const { heroSections, isLoading: isLoadingHeroSections } =
    useHeroSectionsByTypePublic(type);
  const [selectedSection, setSelectedSection] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  // Check if the user is on a mobile device
  useEffect(() => {
    const checkDevice = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // Initial check
    checkDevice();
    
    // Add event listener for window resize
    window.addEventListener('resize', checkDevice);
    
    // Cleanup event listener
    return () => {
      window.removeEventListener('resize', checkDevice);
    };
  }, []);

  // Update selectedSection when heroSections data is available
  useEffect(() => {
    if (heroSections && heroSections.length > 0) {
      setSelectedSection(heroSections[0]);
    }
  }, [heroSections]);

  // Get content data based on category
  const getContentData = (section) => {
    if (category === "audio") {
      return section?.audio_data || {};
    } else if (category === "book") {
      return section?.ebook_data || {};
    }
    return {};
  };

  // Get appropriate background image based on device type
  const getBackgroundImage = (section) => {
    return isMobile 
      ? section.mobile_image || "https://www.w3schools.com/w3images/lights.jpg"
      : section.computer_image || "https://www.w3schools.com/w3images/lights.jpg";
  };

  // Get navigation URL based on category
  const getNavigationUrl = (contentData) => {
    if (category === "audio") {
      return `/audio-play/${contentData.slug}`;
    } else if (category === "book") {
      return `/book-detail/${contentData.slug}`;
    }
    return "#";
  };

  // Get icon based on content type
  const getActionIcon = () => {
    if (category === "audio") {
      return <Play size={18} color="black" fill="black" />;
    } else if (category === "book") {
      return <BookOpen size={18} color="black" />;
    }
    return null;
  };

  // Get action button text
  const getActionText = () => {
    if (category === "audio") {
      return "Listen";
    } else if (category === "book") {
      return "Read";
    }
    return "View";
  };

  const handleSlideChange = (swiper) => {
    if (heroSections && heroSections.length > 0) {
      setSelectedSection(heroSections[swiper.activeIndex]);
    }
  };

  if (isLoadingHeroSections) {
    return (
      <div className={styles.loadingContainer}>
        <Loading />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {heroSections && heroSections.length > 0 && (
        <Swiper
          className={styles.heroSwiper}
          modules={[Autoplay, EffectFade]}
          effect="fade"
          slidesPerView={1}
          speed={5000}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          onSlideChange={handleSlideChange}
        >
          {heroSections.map((section) => {
            const contentData = getContentData(section);
            const navigationUrl = getNavigationUrl(contentData);
            
            return (
              <SwiperSlide key={section.id} className={styles.heroSlide}>
                <div
                  className={styles.heroSection}
                  onClick={() => navigate(navigationUrl)}
                  style={{
                    backgroundImage: `url(${getBackgroundImage(section)})`,
                  }}
                >
                  <div className={styles.gradient} />
                  <div className={styles.content}>
                   
                    
                    <div className={styles.buttonGroup}>
                      <button
                        className={styles.listenButton}
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(navigationUrl);
                        }}
                      >
                        <span className={styles.playIconWrapper}>
                          {getActionIcon()}
                        </span>
                        <span>{getActionText()}</span>
                      </button>
                      <button
                        className={styles.moreButton}
                        
                      ><Info />
                        Info
                      </button>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      )}
      <div className={styles.swiperPagination}></div>
    </div>
  );
};

export default OverlayHome;